import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { useSelector } from "react-redux";
import { useNotification } from "../../State/Hooks/useNotificationHooks";
import { selectNotification } from "../../State/Slices/NotificationSlice";

export function RenderSnackbar() {
  const notification = useSelector(selectNotification);
  const { clearNotification } = useNotification();

  const handleClose = (_: unknown, reason?: SnackbarCloseReason) =>
    reason !== "clickaway" && clearNotification();

  return (
    <Snackbar
      open={notification.open}
      onClose={handleClose}
      autoHideDuration={notification.timeout}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      data-test="snackbar"
    >
      <Alert
        variant="filled"
        onClose={handleClose}
        severity={notification.type}
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
